import apiSkobo from "@/helpers/api/apiSkobo";
import apiGraph from "@/helpers/api/apiGraph";
import Vue from "vue";
import FileHelper from "@/helpers/utilities/FileHelper";

import { useMeStore } from "@/stores/me";
import { useSettingsStore } from "@/stores/settings";
import { useSectionsStore } from "@/stores/sections";

import Permission from "@/models/Documents/Permission";

export const sharedDrives_state = {
  sharedDrivesArray: [] // { driveId: "", itemId: "", displayName: "" },
};

export const sharedDrives_actions = {
  /**
   *  Load Shared SharePointFolders for user
   */
  async loadSharedDrives() {
    if (this.sharedDrivesArray.length === 0) {
      await this.reloadSharedDrives();
    }
  },

  /**
   *  Reload Shared SharePointFolders for user
   */
  async reloadSharedDrives() {
    const result = await apiSkobo.get("/appsharepointfolder");
    this.sharedDrivesArray = result.data.map(d => {
      d.driveId = d.driveId.trim();
      return d;
    });
  },

  /**
   * Temporary load weburls for appsharepointfolders
   * @param { string } driveId DriveId to get weburl for
   * @param { string } itemId  ItemId to get weburl for
   * @returns { string } WebUrl
   */
  async loadSharedDrivesWebUrl(driveId, itemId) {
    const result = await apiGraph.get(`/drives/${driveId}/items/${itemId}?$SELECT=webUrl`);

    const sharedDrivesClone = this.sharedDrivesArray;

    if (!sharedDrivesClone[driveId]) {
      sharedDrivesClone[driveId] = {};
    }
    if (!sharedDrivesClone[driveId][itemId]) {
      sharedDrivesClone[driveId][itemId] = {};
    }

    sharedDrivesClone[driveId][itemId].webUrl = result.data.webUrl;
    Vue.set(this, "sharedDrivesArray", sharedDrivesClone);

    return result.data.webUrl;
  }
};

export const sharedDrives_getters = {
  sharedDrives(state) {
    return state.sharedDrivesArray;
  },

  sharedDrivesICanCopyFilesFrom() {
    const meStore = useMeStore();
    const sectionsStore = useSectionsStore();
    const settingsStore = useSettingsStore();

    const driveGroups = [];

    if (settingsStore.copyDocumentsFromOneDrive) {
      driveGroups.push({
        parentReference: {
          driveId: this.myDriveRootId
        },
        name: "OneDrive"
      });
    }

    // Sectiondrives
    if (settingsStore.copyFromShouldIncludeSections) {
      try {
        const sectionDrives = sectionsStore.mySectionsDrives.map(d => ({
          parentReference: {
            driveId: d.driveId
          },
          name: d.name,
          additionalData: d.additionalData
        }));
        driveGroups.push(...sectionDrives.sort((a, b) => a.name.localeCompare(b.name, settingsStore.language)));
        // eslint-disable-next-line no-empty
      } catch {}
    }

    // SharePoint folders
    try {
      const sharedDrives = this.sharedDrives.filter(spf => {
        if (spf.canCopyFromRoleRestriction) {
          if (meStore.isStudent && spf.canCopyFromRoleRestriction.indexOf("student") > -1) return true;

          if (meStore.isTeacher && spf.canCopyFromRoleRestriction.indexOf("teacher") > -1) return true;

          if (meStore.isSuperuser && spf.canCopyFromRoleRestriction.indexOf("superuser") > -1) return true;
        }
        return false;
      });

      driveGroups.push(
        ...sharedDrives
          .filter(
            spf =>
              this.myItemPermission(spf.driveId, spf.itemId) &&
              (this.myItemPermission(spf.driveId, spf.itemId).myPermission === Permission.nctPermission.WRITE ||
                this.myItemPermission(spf.driveId, spf.itemId).myPermission === Permission.nctPermission.READ ||
                this.myItemPermission(spf.driveId, spf.itemId).myPermission === Permission.nctPermission.OWNER)
          )
          .sort((a, b) => a.displayName.localeCompare(b.displayName, settingsStore.language))
          .map(d => ({
            name: d.displayName,
            id: d.itemId,
            parentReference: { driveId: d.driveId },
            extension: FileHelper.getClosedFolderTemplate(),
            isFolder: true
          }))
      );
      // eslint-disable-next-line no-empty
    } catch {}
    return driveGroups;
  }
};
